// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2xwb6","inner":"Footer_inner__3EJnc","nextIcon":"Footer_nextIcon__2ngZQ","innerLeft":"Footer_innerLeft__4Rtir"};